import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const GIFIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M4 0C3.45 0 3 0.45 3 1V15C3 15.55 3.45 16 4 16H14C14.55 16 15 15.55 15 15V4L11 0H4Z"
      fill="#E2E5E7"
    />
    <path d="M12 4H15L11 0V3C11 3.55 11.45 4 12 4Z" fill="#B0B7BD" />
    <path d="M15 7L12 4H15V7Z" fill="#CAD1D8" />
    <path
      d="M13 13C13 13.275 12.775 13.5 12.5 13.5H1.5C1.225 13.5 1 13.275 1 13V8C1 7.725 1.225 7.5 1.5 7.5H12.5C12.775 7.5 13 7.725 13 8V13Z"
      fill="#BAE850"
    />
    <path
      d="M12.5 13.5H3V14H12.5C12.775 14 13 13.775 13 13.5V13C13 13.275 12.775 13.5 12.5 13.5Z"
      fill="#CAD1D8"
    />
    <path
      d="M5.88148 11.6484C5.54318 11.8948 5.12865 12 4.70995 12C3.70935 12 3 11.4976 3 10.5018C3 9.65673 3.74807 9 4.75223 9C5.12865 9 5.54259 9.11303 5.838 9.36839C6.12865 9.61905 5.70935 9.99163 5.42406 9.77028C5.24777 9.61905 5 9.50654 4.75223 9.50654C4.1763 9.50654 3.61942 9.91209 3.61942 10.5018C3.61942 11.1214 4.08577 11.4976 4.70995 11.4976C5 11.4976 5.24777 11.4223 5.42406 11.3093V10.7954H4.70995C4.28588 10.7954 4.32877 10.2841 4.70995 10.2841H5.6623C5.8386 10.2841 6 10.4019 6 10.5317V11.4228C6 11.4976 5.96248 11.5683 5.88148 11.6484Z"
      fill="white"
    />
    <path
      d="M7.00003 9.26968C7.00003 8.91687 7.62537 8.90341 7.62537 9.26968V10.4991V11.7285C7.62537 12.0862 7.00003 12.0948 7.00003 11.7285V9.26968Z"
      fill="white"
    />
    <path
      d="M9.03177 9.56443V10.2536H10.0684C10.2148 10.2536 10.3612 10.4097 10.3612 10.561C10.3612 10.7041 10.2148 10.8213 10.0684 10.8213H9.03177V11.7316C9.03177 11.8834 8.93061 12 8.78826 12C8.6093 12 8.5 11.8834 8.5 11.7316V9.26893C8.5 9.11332 8.60981 9 8.78826 9H10.2153C10.3943 9 10.5 9.11332 10.5 9.26893C10.5 9.40774 10.3943 9.56389 10.2153 9.56389L9.03177 9.56443Z"
      fill="white"
    />
  </SvgIcon>
);
export default GIFIcon;
